// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tjHb","rootMobile":"styles_rootMobile__2VSlc"};